import { createApiCall2, MethodType, URI } from "../Api";
import { LoginData } from "models/authentication";

export const fetchLogin = (payload: LoginData) => {
  return createApiCall2(MethodType.POST, URI.AUTH.LOGIN, payload);
};
